import React from 'react';

import {IReferenceParamKey} from 'entities/metadata';

import {
    useCustomSelectReferenceOptionsFetcher,
} from '../custom-select/hooks/use-custom-select-reference-options-fetcher/use-custom-select-reference-options-fetcher';
import {StaticSelect, IStaticSelectProps} from '../static-select/static-select';
import {getReferenceURLQueryParamsFromForm} from './utils/string-select.utils';

export interface IStringSelectProps extends IStaticSelectProps {
    referenceUrl?: string;
    referenceParamsKeys?: IReferenceParamKey[];
}

export const StringSelect = ({
    referenceUrl, referenceParamsKeys, form, ...props
}: IStringSelectProps) => {
    const url = (() => {
        const querySuffix = new URLSearchParams(
            getReferenceURLQueryParamsFromForm(form, referenceParamsKeys),
        ).toString();
        return querySuffix ? `${referenceUrl}?${querySuffix}` : referenceUrl;
    })();

    const {entriesFromFetcher} = useCustomSelectReferenceOptionsFetcher({referenceUrl: url});

    return (
        <StaticSelect
            {...props}
            form={form}
            options={entriesFromFetcher}
        />
    );
};
